// extracted by mini-css-extract-plugin
module.exports = {"hidden":"infoDetailArticleMain_hidden__f3BFx","textEmphasis":"infoDetailArticleMain_textEmphasis__tMby3","content":"infoDetailArticleMain_content__saBdF"};